<template>
  <div id="footer" class="container-fluid">
    <p class="title">{{config.name}}</p>
    <p class="address_tel_fax">
      <span>地址: {{config.address}}</span>
      <span style="margin-left:20px">联系电话: {{config.phone}}</span>
    </p>
    <p class="email_wx">
      <span>邮箱: {{config.email}}</span>
      <span style="margin-left:20px">公司微信号: {{config.wechat}}</span>
    </p>
    <p class="copy">Copyright &copy; 2020 - 2022 {{config.name}}</p>
    <a href="http://beian.miit.gov.cn" target="_blank">{{config.keepOnRecordIcp}}</a>
  </div>
</template>
<script>
import config from '@/config'
export default {
  name: "Footer",
  data() {
    return {
      config: config
    };
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #fba039;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 95px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin: 10px;
}
.address_tel_fax {
  color: white;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: white;
  font-size: 14px;
}
.copy {
  color: white;
  font-size: 14px;
  margin: 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
    margin-left: 30px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 20px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue